import React, { PureComponent } from "react";
import { $t } from '@/modules/i18n';

const Faq = ({ Message: msg }) => {
  const faqs = [{
    id: 'faq-a',
    title: msg.faqTitle01,
    datas: msg.faqData01
  }, {
    id: 'faq-b',
    title: msg.faqTitle02,
    datas: msg.faqData02
  }, {
    id: 'faq-c',
    title: msg.faqTitle03,
    datas: msg.faqData03
  }, {
    id: 'faq-d',
    title: msg.faqTitle04,
    datas: msg.faqData04
  }]
  return (
    <section id="faq">
      <div className="container">
        <div className="title-block">
          <h2>{$t(msg.faq)}</h2>
        </div>
        {
          faqs.map(faq => (
            <div key={faq.title}>
              <h4>{$t(faq.title)}</h4>
              {
                (faq.datas || []).map((item, index) => {
                  return (
                    <div className="row" key={index}>
                      <div className="col-md-8 offset-md-2">
                        <h6 className="question" data-toggle="collapse" data-target={`#${faq.id}` + index + 1} aria-expanded="true" aria-controls="collapseOne">
                          <svg width="1em" height="1em" viewBox="0 0 16 16" className="ion" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                            <path fillRule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                          </svg>
                          <span className="question-text">
                            <b>Q{index + 1}:</b>
                            {$t(item.question)}
                          </span>
                        </h6>
                        <div id={faq.id + index + 1} className="collapse card-body" aria-labelledby="headingOne" data-parent="#faq">
                          <p className="desc" dangerouslySetInnerHTML={{ __html: $t(item.answer) }}></p>
                        </div>
                      </div>
                    </div >
                  )
                })
              }
            </div>
          ))
        }
      </div>
    </section>
  )
}

export default Faq;